import {createSpin as createSpin2} from "./createSpin";
import Spin from "./spin.vue";
const spin2 = createSpin2(Spin);
export default spin2;
